/**=========================================================
 * Module: app-counter.js
 * Counter widget
 =========================================================*/

App.directive('appCounter', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/counter.html',
      controller: 'CounterController',
      restrict: 'E',
      replace: true,
      scope: { 
          cid: '@cid',
          icon: '@icon',
          label: '@label'
      }
  };

});
